import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const modules = [
  require('./account'),
  require('./agreement'),
  require('./auth'),
  require('./choice'),
  require('./collectionAccount'),
  require('./contract'),
  require('./document'),
  require('./earlyPayment'),
  require('./env'),
  require('./errors'),
  require('./evaluation'),
  require('./fundaPaygate'),
  require('./kyc'),
  require('./loan'),
  require('./loansRequest'),
  require('./nice'),
  require('./overlay'),
  require('./meta'),
  require('./myfinbiz'),
  require('./signup'),
  require('./store'),
  require('./status'),
  require('./system'),
  require('./time'),
  require('./withdrawalAccount'),
  require('./ui/ui'),
  require('./ui/header'),
  require('./credit-pay/wholesaler'),
  require('./credit-pay/payment'),
  require('./proxyCode'),
  require('./loanMarketplace'),
].reduce((map, module) => {
  const d = module.default
  map[d.name] = d
  return map
}, {})

export default new Vuex.Store({
  modules,
  // plugins: [
  //   createPersistedState({
  //     paths: ['signup'],
  //   }),
  // ],
})
